import Tools from './tools/Tools';
import SavePiskel from './tools/SavePiskel';
import Frames from './frames/Frames';
import Animation from './frames/FramesAnimation';

export default class App {
    constructor() {
        this.state = {
            curentColor: '#1abc9c',
            prevColor: 'e67e22',
            curentTool: 'pen',
            fps: 12,
            frames: [
                `url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAALUlEQVRYR+3QQREAAAABQfqXFsNnFTizzXk99+MAAQIECBAgQIAAAQIECBAgMBo/ACHo7lH9AAAAAElFTkSuQmCC')`
            ],
            shortcut: {
                pen: 'KeyP',
                eraser: 'KeyE',
                verticalMirror: 'KeyM',
                colorPicker: 'KeyI',
                rectangle: 'KeyR',
                paintBucket: 'KeyB',
                lighten: 'KeyL',
                newFrame: 'KeyN',
                dublicateFrame: 'KeyD',
                deleteFrame: 'KeyT'
            }
        };
    }

    start() {
        this.state.curentColor =
            JSON.parse(localStorage.getItem('curentColor')) || this.state.curentColor;

        this.state.prevColor =
            JSON.parse(localStorage.getItem('prevColor')) || this.state.prevColor;

        this.state.curentTool =
            JSON.parse(localStorage.getItem('curentTool')) || this.state.curentTool;

        this.state.fps = JSON.parse(localStorage.getItem('fps')) || this.state.fps;

        this.state.shortcut = JSON.parse(localStorage.getItem('shortcut')) || this.state.shortcut;

        const tools = new Tools(this.state);
        const savePiskel = new SavePiskel(this.state);
        const frames = new Frames(this.state);
        const framesAnimation = new Animation(this.state);

        tools.start();
        savePiskel.save();
        frames.start();
        framesAnimation.start();

        window.onbeforeunload = () => {
            localStorage.setItem('curentColor', JSON.stringify(this.state.curentColor));
            localStorage.setItem('prevColor', JSON.stringify(this.state.prevColor));
            localStorage.setItem('curentTool', JSON.stringify(this.state.curentTool));
            localStorage.setItem('fps', JSON.stringify(this.state.fps));
            localStorage.setItem('shortcut', JSON.stringify(this.state.shortcut));
            return 'Данные не сохранены. Точно перейти?';
        };
    }
}
